import type React from 'react';

export type SelectInputProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export function SelectInput({ className, children, value, ...props }: SelectInputProps): JSX.Element {
  return (
    <select
      className={[
        'block w-full rounded-md border border-slate-300 px-3 py-2 text-sm',
        'shadow-sm focus:border-slate-500 focus:ring-1 focus:ring-slate-500',
        'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      value={value ?? ''}
      {...props}
    >
      {children}
    </select>
  );
}
